/**
 * Spinner Component
 * 
 * Animated loading spinner using Framer Motion for React compatibility.
 * Uses the same easing curve as other site animations.
 */

import React from 'react';
import { motion } from 'framer-motion';

function Spinner({
    size = 'md',
    className = '',
    color = 'wine'
}) {
    // Size mapping
    const sizeClasses = {
        xs: 'w-3 h-3 border',
        sm: 'w-4 h-4 border-2',
        md: 'w-6 h-6 border-2',
        lg: 'w-8 h-8 border-2',
        xl: 'w-12 h-12 border-4'
    };

    // Color mapping for border
    const colorClasses = {
        wine: 'border-wine-500/30 border-t-wine-500',
        gold: 'border-gold-500/30 border-t-gold-500',
        white: 'border-white/30 border-t-white',
        cream: 'border-cream/30 border-t-cream'
    };

    return (
        <motion.div
            className={`rounded-full ${sizeClasses[size] || sizeClasses.md} ${colorClasses[color] || colorClasses.wine} ${className}`}
            animate={{ rotate: 360 }}
            transition={{
                duration: 1,
                ease: 'linear',
                repeat: Infinity
            }}
        />
    );
}

export default Spinner;
